import { useQuery } from "react-query"
import { fetchFuels } from "./api"

// eslint-disable-next-line import/prefer-default-export
export const useFetchFuels = params => {
  return useQuery(["fetchFuels", params], fetchFuels)
}
